const ProductSizeWeightIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="product-size-weight-grad" x1="-8.55" y1="24.8889" x2="26.7175" y2="0.48067" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #EE5B33)"/>
        <stop offset="0.992382" stopColor="var(--s247-icon-end, #AB2A86)"/>
      </linearGradient>
    </defs>
    <path d="M9 0C9.95478 0 10.8705 0.374602 11.5456 1.0414C12.2207 1.70819 12.6 2.61256 12.6 3.55556C12.6 4.20444 12.429 4.80889 12.114 5.33333H14.4C15.255 5.33333 15.975 5.92889 16.155 6.72C17.964 13.84 18 14.0267 18 14.2222C18 14.6937 17.8104 15.1459 17.4728 15.4793C17.1352 15.8127 16.6774 16 16.2 16H1.8C1.32261 16 0.864773 15.8127 0.527208 15.4793C0.189642 15.1459 0 14.6937 0 14.2222C0 14.0267 0.0360002 13.84 1.845 6.72C2.025 5.92889 2.745 5.33333 3.6 5.33333H5.886C5.56428 4.79502 5.39632 4.18064 5.4 3.55556C5.4 2.61256 5.77928 1.70819 6.45442 1.0414C7.12955 0.374602 8.04522 0 9 0ZM9 1.77778C8.52261 1.77778 8.06477 1.96508 7.72721 2.29848C7.38964 2.63187 7.2 3.08406 7.2 3.55556C7.2 4.02705 7.38964 4.47924 7.72721 4.81263C8.06477 5.14603 8.52261 5.33333 9 5.33333C9.47739 5.33333 9.93523 5.14603 10.2728 4.81263C10.6104 4.47924 10.8 4.02705 10.8 3.55556C10.8 3.08406 10.6104 2.63187 10.2728 2.29848C9.93523 1.96508 9.47739 1.77778 9 1.77778ZM3.6 7.11111V14.2222H5.4V12L6.3 12.8889V14.2222H8.1V12.4444L6.3 10.6667L8.1 8.88889V7.11111H6.3V8.44444L5.4 9.33333V7.11111H3.6ZM11.7 7.11111C10.701 7.11111 9.9 7.90222 9.9 8.88889V12.4444C9.9 13.4311 10.701 14.2222 11.7 14.2222H14.4V9.77778H12.6V12.4444H11.7V8.88889H14.4V7.11111H11.7Z" fill="url(#product-size-weight-grad)"/>
  </svg>
);
import Section from 'Components/Section';
import { C2C_WEIGHT_MAX } from 'Pages/C2cOrderPayment/constants';
import {
  C2cCategoryPackageTypeEnum,
  C2cOverPaymentTextEnum
} from 'Pages/C2cOrderPayment/enums';
import { C2cSelectWeightConfigModel } from 'Pages/C2cOrderPayment/models';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  c2cOrderPaymentSelectors,
  C2cOverPaymentState,
  onChangeWeightAction,
} from 'Stores/c2c-order-payment';
import { APRICOT_PEACH_BLOSSOM } from 'Utilities/constants';
import { ExtraService, SelectSize, SelectWeight } from '..';
import './styles.scss';

interface ProductSizeAndWeightProps {
  onAfterChange: () => void;
}

const ProductSizeAndWeight = (props: ProductSizeAndWeightProps) => {
  const { onAfterChange } = props;
  const { t } = useTranslation();

  const [weightConfig, setWeightConfig] = useState(
    {} as C2cSelectWeightConfigModel
  );
  const dispatch = useDispatch();
  const {
    weightAndSize,
    c2cValidateFields,
    packageTypeSelected,
    toggleOrder,
    isGlobal,
    globalDirection,
    productSelected,
  } = useSelector(c2cOrderPaymentSelectors.get) as C2cOverPaymentState;

  const [_weight, setWeight] = useState(weightAndSize?.weight);
  useEffect(() => {
    setWeight(weightAndSize?.weight);
  }, [weightAndSize?.weight]);

  useEffect(() => {
    let weightCf = C2C_WEIGHT_MAX.ParcelKR;

    if (
      isGlobal &&
      packageTypeSelected === C2cCategoryPackageTypeEnum.Document
    ) {
      weightCf = C2C_WEIGHT_MAX.DocumentKR;
    }
    if (
      !isGlobal &&
      packageTypeSelected === C2cCategoryPackageTypeEnum.Parcel
    ) {
      weightCf = C2C_WEIGHT_MAX.ParcelVN;
    }
    if (
      !isGlobal &&
      packageTypeSelected === C2cCategoryPackageTypeEnum.Document
    ) {
      weightCf = C2C_WEIGHT_MAX.DocumentVN;
    }
    setWeightConfig(weightCf);
  }, [isGlobal, packageTypeSelected]);

  return (
    <Section
      className="c2c-product-size-and-weight"
      title={t(C2cOverPaymentTextEnum.PSAW_ExtraService_Title)}
      icon={<ProductSizeWeightIcon />}
    >
      {productSelected.code !== APRICOT_PEACH_BLOSSOM.code && (
        <div className="c2c-size-weight-container row">
          <SelectWeight
            className="c2c-select-weight col-xl-6 col-12 pe-6"
            marks={weightConfig?.marks}
            tipFormatter={null}
            decimal={weightConfig?.decimal}
            max={weightConfig?.max}
            min={weightConfig?.min}
            value={_weight}
            validationField={{
              ...c2cValidateFields.weight,
              toggle: toggleOrder
            }}
            onChange={value => setWeight(value)}
            onAfterChange={value => dispatch(onChangeWeightAction(value))}
          ></SelectWeight>
          <SelectSize
            className="c2c-select-size ms-0 col-xl-5 col-12"
            onAfterChange={onAfterChange}
          ></SelectSize>
        </div>
      )}
      {(!isGlobal || (isGlobal && globalDirection === 'outbound')) && (
        <ExtraService
          title={t(C2cOverPaymentTextEnum.PSAW_ExtraService_Title)}
          className="c2c-extraService"
        ></ExtraService>
      )}
    </Section>
  );
};

export default ProductSizeAndWeight;
